import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'bangladesh_does_facility_have_legally_required_qualified_welfare'

export const dataPointDefinition = {
  retracedId: 'bangladesh_does_facility_have_legally_required_qualified_welfare',
  name: 'Bangladesh: Does the facility have legally required qualified welfare officer/s?',
  description:
    'This question is specific to Bangladesh only. Please consult the Law Overlay for more information on applicable legal requirements. ',
  meta: {
    slcpMeta: {
      key: 'wi-wor-19',
      number: 'WI-WOR-16',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wi-wor-19', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36980,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
